import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useT } from "@/lib/i18n";

export default function Faq() {
  const t = useT();
  const FAQS = t.faq.items;
  return (
    <section data-testid="faq-section" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] font-semibold mb-5">
            {t.faq.eyebrow}
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#F5F5F0]">
            {t.faq.titleA}
            <br />
            <span className="italic text-[#A3A3A3]">{t.faq.titleB}</span>
          </h2>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#2A2A2A]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-lg md:text-xl text-[#F5F5F0] hover:text-[#D4AF37] py-6 font-serif-display tracking-tight">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A3A3A3] text-base leading-relaxed pb-6 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
